import { Component } from '@angular/core';
import { TracesService } from '../../services/http/traces/traces.service';
import { Trace } from '../../services/http/traces/traces.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'app-traces',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './traces.component.html',
  styleUrl: './traces.component.scss'
})
export class TracesComponent {
  from = new Date(Date.now() - 1000 * 60 * 60 * 24);
  to = new Date(Date.now());
  limit = 100;
  page = 1;
  order = 'desc';
  totalPages = 0;
  traces: Trace[] = [];
  
  constructor(
    private readonly tracesService: TracesService,
    private readonly loaderService: LoaderService
  ) {
    this.loadTraces();
  }

  get pages(): number[] {
    const pages = [];
    for (let i = 1; i <= this.totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  loadTraces() {
    this.loaderService.show();
    this.tracesService.getTraces(this.from, this.to, this.limit, this.page, this.order).subscribe((data) => {
      this.traces = data.elements;
      this.totalPages = data.pages;
      this.loaderService.hide();
    });
  }
}
